/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-events',
    'pip-common.utils',
    'window',
    'pip-model'

  ],
  function(
    pipEvents,
    pipCommonUtils,
    window,
    pip
  ){
    function initEventListeners(){
      pipEvents.cart.addToCartAnalyticsBackorder.on(function(evtType, data) {
        var fulfillmentMap = {
          'ShipToHome': 'sth',
          'ShipToStore': 'boss',
          'BOPIS': 'bopis',
          'DirectDelivery': 'appl',
          'DeliverFromStore': 'bodfs',
        }
        var fulfillmentMethod = data.fulfillmentMethod
        var isStoreSet = fulfillmentMethod === 'ShipToStore' || data.fulfillmentMethod === 'BOPIS';
        var isZipSet = data.fulfillmentMethod === 'DirectDelivery' || data.fulfillmentMethod === 'DeliverFromStore';
        var digitalDataObject = {
          category: {
            primaryCategory: "overlay"
          },
          eventInfo: {
            eventName: "cart add"
          },
          item: [{
            productInfo: {
              sku: pip.products.primary.data.itemId,
            },
            quantity: pipCommonUtils.deepGet(pip, 'customer.quantity'),
            price: {
              basePrice: pipCommonUtils.deepGet(pip, 'products.primary.data.itemExtension.pricing.originalPrice'),
              priceType: pipCommonUtils.deepGet(pip, 'products.primary.data.itemExtension.pricing.priceType')
            },
            fulfillment: {
              method: fulfillmentMap[data.fulfillmentMethod],
              backOrder: pipCommonUtils.deepGet(pip, 'products.primary.data.itemAvailability.backorderable') ? 'yes' : 'no',
            }
          }]
        };
        if (isStoreSet) {
          digitalDataObject.item[0].fulfillment.store = pip.customer.storeForPurchase
        }
        if (isZipSet) {
          digitalDataObject.item[0].fulfillment.zip = pip.customer.dynamicEtaZipCode ? pip.customer.dynamicEtaZipCode : pip.customer.localStore.zipCode
        }
        pushAnalyticsEvent(digitalDataObject);
      });
    }

    function pushAnalyticsEvent(analyticsEventObject) {

      if (pip.debugMode) {
        console.log('DDO Add to Cart Event:', analyticsEventObject);
      }

      if (window.digitalData && window.digitalData.event) {
        window.digitalData.event.push(analyticsEventObject);
      }
    }

    return {
      init: function(){
        initEventListeners();
      }
    }
  });

}.call(window));